import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { map, Observable } from 'rxjs';
import { endPoints } from '../api-end-points';
import { Forum } from '../Models/Forum';

@Injectable({
  providedIn: 'root',
})
export class ForumService {
  constructor(private apiService: ApiCallService) { }

  create(post: any): Observable<string> {
    return this.apiService.Post(endPoints.CREATE_QUESTION, JSON.stringify(post));
  }

  getDataByCat(catid: any, startIndex: number, endIndex: number, grade: any): Observable<Array<any>> {
    grade = grade === undefined || grade === null || grade === '' ? 12 : grade;
    // return this.apiService.Get(endPoints.GET_DATA_BY_CATEGORY + `${catid}?startIndex=${startIndex}&lastIndex=${endIndex}&grade=${grade}`);
    return this.apiService.Get(endPoints.GET_DATA_BY_CATEGORY + `${catid}/${grade}/${startIndex}/${endIndex}`);
  }
  getRandomDataByCat(catid: any): Observable<Array<any>> {
    return this.apiService.Get(endPoints.GET_DATA_RANDOM_BY_CATEGORY + `catid=${catid}`);
  }

  getSimilarQuestion(EnterQuestion: string): Observable<any> {
    const params = { EnterQuestion };
    return this.apiService.Get(endPoints.GET_SIMILAR_QUESTION, params);
  }

  getForumTagList(): Observable<any> {
    return this.apiService.Get(endPoints.GET_FORUM_TAGS);
  }

  getAnswerdata(QuestionId: any): Observable<any> {
    const params = `${QuestionId}`;
    var response= this.apiService.Get(endPoints.GET_ANSWERS + params);
    return response;
  }

  createAnswer(post: any): Observable<any> {
    return this.apiService.Post(endPoints.CREATE_ANSWER, JSON.stringify(post));
  }

  getQuestion(id: any): Observable<any> {
    return this.apiService.Get(endPoints.GET_QUESTION + id);
  }

  EditQuestions(PUT: Forum, id: number): Observable<any> {
    return this.apiService.Put(endPoints.GET_QUESTION + id, JSON.stringify(PUT));
  }
  updateQuestion(id: any, answerCount: any) {
    return this.apiService.Patch(endPoints.UPDATE_QUESTION + id, JSON.stringify(answerCount), { 'Content-Type': 'application/json; charset=utf-8' }, 'text');
  }
  getProhibitedPatterns(): Observable<string[]> {
  return this.apiService.GetJson('/assets/data/ProhibitedWords.json').pipe(
    map((res: any) => res.ProhibitedWordsAndPatterns || []) // safely return array
  );
}
}
